import { PromoterModel, PromoterTypes } from '@mm/state/model/PromoterModel';
import getPromoterValue from '../../build/constants/getPromoterValue';
import getPromoterGlobalJSValue from '../../build/constants/getPromoterGlobalJSValue';

const { LINK, CUSTOMER_CHAT } = PromoterTypes;

export type CustomisedPromoterModel = PromoterModel & {
  initInGreeting: string;
  initOutGreeting: string;
};

type GetValueByTypeProps = {
  promoter: CustomisedPromoterModel | PromoterModel;
  globalJavascriptBaseUrl: string;
  fbPageId: string;
  appId: string;
  type: string;
};

export const getValueByType = (props: GetValueByTypeProps) => {
  const { promoter, globalJavascriptBaseUrl, fbPageId, appId, type } = props;
  const {
    searchToken,
    loggedInGreeting: inValue,
    loggedOutGreeting: outValue,
    color: promoterColor,
    useGlobalJs,
  } = promoter;

  const initInGreeting = inValue || 'Hi! How can we help you?';
  const initOutGreeting =
    outValue || "Hi! We're here to answer any questions you may have";
  const color = promoterColor || '#0084FF';

  if (type === LINK) {
    const slug = promoter && promoter.slug;
    return slug ? promoter.slugLink : promoter.tokenLink;
  }

  if (useGlobalJs) {
    return getPromoterGlobalJSValue({
      type,
      globalJavascriptBaseUrl,
      pageId: fbPageId,
      ref: searchToken,
    });
  }

  switch (type) {
    case CUSTOMER_CHAT:
      return getPromoterValue({
        type,
        pageId: fbPageId,
        appId,
        ref: searchToken,
        loggedInGreeting: initInGreeting,
        loggedOutGreeting: initOutGreeting,
        themeColor: color,
      });
    default:
      return getPromoterValue({
        type,
        pageId: fbPageId,
        appId,
        ref: searchToken,
      });
  }
};
